/**
 * Iframe
 *
 * @selector [data-js-iframe]
 * @enabled true
 */
import BaseModule from '../../modules/BaseModule.js';
import 'iframe-resizer/js/iframeResizer';

export default class Iframe extends BaseModule {
    constructor() {
        super();
    }

    init(element) {
        this.el = element;

        iFrameResize({ log: true }, this.el.querySelector('iframe'));

        return this;
    }
}
